import React from 'react';

import { Button } from '@occc/ui-design-system';

import { MessagingCampaignTabs } from '../../messaging-campaign-configure.constants';

export type CampaignComponentFooterActionsProps = {
  onCancel: () => void;
  onNextStepClick: () => void;
  isSubmitDisabled: boolean;
  currentTab: MessagingCampaignTabs;
  isUserPermittedToEdit: boolean;
};

export const FooterActions = ({
  onCancel,
  onNextStepClick,
  isSubmitDisabled,
  currentTab,
  isUserPermittedToEdit,
}: CampaignComponentFooterActionsProps) => {
  const saveActionTitle = 'Save changes';
  const actionButtonTitle =
    currentTab !== MessagingCampaignTabs.Schedule ? 'Continue' : saveActionTitle;

  return (
    <>
      <Button onClick={onCancel}>Cancel</Button>

      {isUserPermittedToEdit ? (
        <Button type='submit' color='primary' variant='contained' disabled={isSubmitDisabled}>
          {actionButtonTitle}
        </Button>
      ) : (
        <Button onClick={onNextStepClick} color='primary' variant='contained'>
          Next
        </Button>
      )}
    </>
  );
};
